import type { FC } from "react";
import React from "react";

import { bindArgs } from "@core/foundation/function";

import { Button } from "@react/ui-primitives/button";

import type { GithubConnection } from "@apis/account/models";

import { useGithubActions } from "../hooks/useGithubActions.ts";

function getStatusLabel(
  status: GithubConnection["status"],
  repoCount: number,
): string {
  switch (status) {
    case "active":
      return `${repoCount} repositories`;
    case "disconnected":
      return "Disconnected";
  }
}

interface GithubConnectionCardProps {
  readonly githubConnection: GithubConnection;
  readonly repoCount: number;
}

export const GithubConnectionCard: FC<GithubConnectionCardProps> = ({
  githubConnection,
  repoCount,
}) => {
  const { disconnect } = useGithubActions();

  const statusLabel = getStatusLabel(githubConnection.status, repoCount);

  return (
    <div className="flex items-center justify-between rounded-md border p-3">
      <div className="flex flex-col">
        <span className="font-medium">
          {githubConnection.githubAccountLogin}
        </span>
        <span className="text-sm text-muted-foreground">{statusLabel}</span>
      </div>
      {githubConnection.status === "active" && (
        <Button
          disabled={disconnect.isPending}
          onClick={bindArgs(disconnect.mutate, {
            githubAccountId: githubConnection.githubAccountId,
          })}
          variant="destructive"
        >
          Disconnect
        </Button>
      )}
    </div>
  );
};
